import Picture, { ImageTransformation } from "../Picture";

import Link from "next/link";

import { Col, Container, Row } from "react-bootstrap";

import styles from "./Breadcrumbs.module.scss";

const Breadcrumbs = ({ parts, title, description, background = null }) => {
  return (
    <nav className={`${styles.breadcrumbs} mb-4 ${background ? styles.hasImage : ""}`}>
      {background && <Picture src={background} className={styles.background} cover={true} />}
      <Container className={styles.content}>
        <ul>
          <li>
            <Link href="/">Home</Link>
          </li>
          {parts?.map((x) => (
            <li key={x.href}>
              <Link href={x.href}>{x.name}</Link>
            </li>
          ))}
        </ul>

        <Row>
          <Col xs={12} sm={6}>
            {title && <h1>{title}</h1>}
            {description && <p>{description}</p>}
          </Col>
        </Row>
      </Container>
    </nav>
  );
};

export default Breadcrumbs;
